import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { activateLoading, deactivateLoading } from './GlobalSlice';
import { fetchMemberDetails } from '../APIServices/MemberService';
import { CUSTOM_ERROR_CODE } from '../../Constants/Constants';
import { isEntitled } from '../../Utils/ContentOrConfigUtil';
export interface IMemberState {
  memberData: any;
}

const initialState: IMemberState = {
  memberData: null,
};

export const globalSlice = createSlice({
  name: 'Member',
  initialState,
  reducers: {
    resetMember: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(retrieveMemberDetails.fulfilled, (state, action: any) => {
      const { configTableData, response } = action?.payload ?? {};
      let res = {
        ...response,
        member: {
          ...response?.member,
          userApplicationDetails: response?.member?.userApplicationDetails?.filter(
            (item: any) => item?.applicationName === 'OWNER OPERATOR',
          ),
        },
      };
      if (isEntitled(res?.member, configTableData, 'app', 'loginAllowed')) {
        state.memberData = res;
      } else throw new Error(CUSTOM_ERROR_CODE.Authorization_Error);
    });
  },
});

export const { resetMember } = globalSlice.actions;
export default globalSlice.reducer;

export const retrieveMemberDetails = createAsyncThunk(
  'Member/getMember',
  async (payload: any, { dispatch }) => {
    try {
      dispatch(activateLoading());
      const response: any = await fetchMemberDetails();
      dispatch(deactivateLoading());
      return { response, configTableData: payload };
    } catch (error) {
      console.error(error);
      dispatch(deactivateLoading());
      return null;
    }
  },
);
